export const ENV = ((): 'local' | 'qa' | 'preprod' | 'prod' => {
  const host = window.location.hostname;

  if (host.includes('local') || host.includes('localhost')) {
    return 'local';
  }
  if (host.includes('dev')) {
    return 'qa';
  }
  if (host.includes('tondril')) {
    return 'preprod';
  }
  return 'prod';
})();
